import React from 'react'
import FormAlongsideText from './FormAlongsideText'
import { Grid } from '@material-ui/core'
import ICommonFormProps from '../interfaces/ICommonFormProps'
import FormWizardButtons from '../FormWizardButtons'
import EColourPanel from '../interfaces/EColourPanel'
import { useTranslation } from 'react-i18next'
import ThumbUpIcon from '@material-ui/icons/ThumbUp';
import ThumbDownIcon from '@material-ui/icons/ThumbDown';

interface IFormButtonWithText extends ICommonFormProps {
  onPressSetLocation: ()=>void
  successText: string
  failureText: string;
  isSuccess?: boolean
}

export function FormButtonWithText(props: IFormButtonWithText) {
  const {t} = useTranslation()

  return (
    <Grid container justify="center" alignItems="center" spacing={1}>
      <Grid item xs={props.formProps?.secondLabel ? 5 : 6}>
          <FormWizardButtons
            rightButton={{
              onClick: props?.formProps?.onPressSetLocation,
              color: EColourPanel.PRIMARY,
              label: props.formProps?.buttonLable,
              type: 'button',
              style: {width: '100%'}
            }}
          />
          <div>
            {
              props?.formProps?.isSuccess ? (
                <span style={{color: 'green', alignItems: 'center', display: 'flex'}} >{t(props?.formProps?.successText)} <ThumbUpIcon/> </span>
              ) : (
                <span style={{color: 'red', alignItems: 'center', display: 'flex'}}>{t(props?.formProps?.failureText)} <ThumbDownIcon/> </span>
              )
            }
          </div>
      </Grid>
      <Grid item xs={props.formProps?.secondLabel ? 7 : 6}>
          <FormAlongsideText
              label={props.formProps?.sideLabel || ''}
              secondLabel={props.formProps?.secondLabel}
          />
      </Grid>
    </Grid>
  )
}
